import { createBooleanStorageItem } from '@page/core/lib/web/storage';

import { useStorageAsState } from '../../web/useStorageAsState';

export const isUserInvitedStorage = createBooleanStorageItem('is-invite', { storage: sessionStorage });

export const useIsUserInvitedStorage = () => {
  return useStorageAsState(isUserInvitedStorage);
};
